import React from 'react'
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import VendorDeptStatContainer from '../../containers/vendor_dept_stat/VendorDeptStatContainer';


const VendorDeptStatViewPage = () => {
    return (
        <div>
            <BreadcrumbsContainer title="통계/수주관리/매출처별 통계" icon="statistics" />
            <VendorDeptStatContainer />
        </div>
    )
}

export default VendorDeptStatViewPage